export default "__VITE_ASSET__7sHDjI20__ 700w, __VITE_ASSET__XV4MUl6M__ 500w";